import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const { incidentsSuccess, incidentByIdSuccess, washPackagesSuccess } = isOfflineDev ? await import("../tests/fixtures/incidents.js") : {};

export async function getIncidentsQuery(query, headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    let url = BACKEND_API_PLACEHOLDER + '/api/incidents/query?'
      for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
        if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
      }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else {
    return incidentsSuccess
  }
}

export async function getIncidentById(id, headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + `/api/incidents/id?id=${id}`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return incidentByIdSuccess
}

export async function postIncidentCreate(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/incidents/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putIncidentsEdit(id, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/incidents/edit?id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getSTWashPackages(headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + `/api/incidents/washes`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return washPackagesSuccess
}